<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper " style="overflow: hidden;" elevation="3" id="printable-area">

          <div class="watermark">
            <img 
              v-if="getSaleInvoiceDelivery?.branch?.company?.watermark && invoiceHeader" 
              :src="getFileServerUrl + getSaleInvoiceDelivery?.branch?.company?.watermark" 
              alt=""
              style="height: 500px"
            >
          </div>

          <div style="margin: 20px;">
            <table style="width: 100%; border-collapse: collapse;">
              <thead>
                <tr v-if="invoiceHeader">
                  <td colspan="100%">
                    <div>
                      <div style="display: flex; justify-content: flex-end; align-items: flex-start; padding-bottom: 10px; margin-bottom: 16px;">
                        <img
                          :src="`${getFileServerUrl}${getSaleInvoiceDelivery?.branch?.company?.logo}`"
                          class="logo-img"
                          alt="Logo"
                          style="max-height: 80px;" 
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              </thead>

              <tbody style="border: 1px solid #000;">
                <tr>
                  <th style="background-color: #d3d3d3;" colspan="100%">
                    <h2 style="font-size: 16px; text-align: center; margin: 4px 0; font-weight: bold;">CHALLAN COPY</h2>
                  </th>
                </tr>

                <tr>
                  <td colspan="100%">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; margin-bottom: 20px;">
                      <tbody>
                        <tr>
                          <td style="width: 50%; vertical-align: top; padding: 8px;">
                            <div style="font-weight: bold; margin-bottom: 4px;">To,</div>

                            <div style=" line-height: 1.4;">
                              <div>{{ getSaleInvoiceDelivery?.invoice_master?.customer?.company_name }}</div>
                              <div style="margin-top: 4px;">{{ getSaleInvoiceDelivery?.invoice_master?.delivery_address }}</div>
                            </div>

                            <div style=" margin-top: 8px;">
                              <strong>Attention:</strong> {{ getSaleInvoiceDelivery?.invoice_master?.customer?.contacts[0]?.name }}
                            </div>

                            <div style=" margin-top: 4px;">
                              <strong>Contact No.:</strong> {{ getSaleInvoiceDelivery?.invoice_master?.customer?.contacts[0]?.mobile }}
                            </div>
                          </td>

                          <td style="width: 50%; vertical-align: top; padding: 8px;">
                            <div style="">
                              <div style="display: flex; margin-bottom: 4px;">
                                <span style="font-weight: bold; width: 40%;">CHALLAN NO:</span>
                                <span>{{ getSaleInvoiceDelivery?.code }}</span>
                              </div>

                              <div style="display: flex; margin-bottom: 4px;">
                                <span style="font-weight: bold; width: 40%;">CHALLAN DATE:</span>
                                <span>{{ formatDateDash(getSaleInvoiceDelivery?.invoice_delivery_date) }}</span>
                              </div>

                              <div style="display: flex; margin-bottom: 4px;">
                                <span style="font-weight: bold; width: 40%;">PO:</span>
                                <span>{{ getSaleInvoiceDelivery?.invoice_master?.po_no || '-' }}</span>
                              </div>

                              <div style="display: flex; margin-bottom: 4px;">
                                <span style="font-weight: bold; width: 40%;">DATE:</span>
                                <span>{{ todayDate }}</span>
                              </div>
                              <div style="display: flex; margin-bottom: 4px;">
                                <span style="font-weight: bold; width: 40%;">SALES PERSON:</span>
                                <span>{{ getSaleInvoiceDelivery?.invoice_master?.employee?.name }}</span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>

                <tr>
                  <td colspan="100%">
                    <table class="dep-table details-table" style="width: 100%; font-size: 13px; border-collapse: collapse;">
                      <thead>
                        <tr style="background-color: #d3d3d3;">
                          <th style="border: 1px solid #000; border-left: none; padding: 1px; text-align: center; width: 40px;">S/L</th>
                          <th style="border: 1px solid #000; padding: 1px;">Code</th>
                          <th style="border: 1px solid #000; padding: 1px;">Item</th>
                          <th style="border: 1px solid #000; padding: 1px;">Lot No</th>
                          <th style="border: 1px solid #000; border-right: none; padding: 1px; text-align: center;">Qty (Kg)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(detail, index) in getSaleInvoiceDelivery?.invoice_delivery_details" :key="detail.id">
                          <td style="border: 1px solid #000; border-left: none; padding: 1px; text-align: center;">{{ index + 1 }}</td>
                          <td style="border: 1px solid #000; padding: 1px;">{{ detail.product?.code }}</td>
                          <td style="border: 1px solid #000; padding: 1px;">{{ detail.product?.name }} {{ detail.remarks && ` / ${detail.remarks}`}}</td>
                          <td style="border: 1px solid #000; padding: 1px;">{{ detail.lot_no }}</td>
                          <td style="border: 1px solid #000; border-right: none; padding: 1px; text-align: center;">{{ detail.qty }}</td>
                        </tr>
                        
                        <tr style="font-weight: bold; background-color:#d3d3d3; margin-top: 10px;">
                          <td colspan="4" style="border: 1px solid #000; border-left: none; text-align: end; padding: 1px;">Total</td>
                          <td style="border: 1px solid #000; border-right: none;  padding: 1px; text-align: center;">{{ getTotalQuantity() }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>

                <tr>
                  <td colspan="100%" style="padding: 12px 10px; font-size: 13px; font-weight: bold;">
                    <div>*Received the above goods in actual weight and good condition</div>
                  </td>
                </tr>

                <tr>
                  <td colspan="100%" style="padding: 12px 10px; font-size: 13px;">
                    <div style="font-size: 12px; padding-top: 10px; background-color: #ffffff;">
                      <p><strong>Description: </strong></p>
                      <div style="margin-left: 20px" v-html="getSaleInvoiceDelivery?.remarks"></div>
                    </div>
                  </td>
                </tr>

                <tr style="display:flex;justify-content:space-between; font-size: 13px; margin-top: 200px;">
                  <td>
                    <div style="width: 300px; border-bottom: 1px solid #000;"></div>
                    <div style="font-weight:700; text-align: center;">Customer</div>
                  </td>
                  <td>
                    <div style="width: 300px; border-bottom: 1px solid #000;"></div>
                    <div style="font-weight:700; text-align: center;">For Remex Ingredient Solution</div>
                  </td>
                </tr>

                <tr style="font-size: 12px">
                  <td>
                    System Generated
                  </td>
                </tr>
              </tbody>  

              <tfoot>
                <tr>
                    <td colspan="100%" style="border:none">
                    <div style="width:100%;height: 70px;">&nbsp;</div>
                    </td>
                </tr>
              </tfoot>
            </table>
          </div>


          <div class="invoice-footer" v-if="invoiceHeader" style="margin-left:10px; color: #343591;">
            <p style="font-size: 13px; font-weight: 500; display: flex; align-items: center; gap:4px">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                <path d="M0 0h24v24H0z" fill="none" />
                <path fill="currentColor" d="M12 11.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7" />
              </svg>

              <span>{{ getSaleInvoiceDelivery?.branch?.company?.address }}</span>
            </p>

            <p style="font-size: 13px; font-weight: 500; display: flex; align-items: center; gap:4px">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                <path d="M0 0h24v24H0z" fill="none" />
                <path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24c1.12.37 2.33.57 3.57.57c.55 0 1 .45 1 1V20c0 .55-.45 1-1 1c-9.39 0-17-7.61-17-17c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02z" />
              </svg>

              <strong>Phone: </strong>  +880 9610-993393, +880 2 222288648, www.remexingredient.com | www.remexcorp.com
            </p>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <v-row justify="end" class="d-print-none mt-4">
      <v-col cols="12" justify="center" style="display:flex; justify-content: center;">
        <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
          Print without pad
        </v-btn>
        <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
          Print with pad
        </v-btn>
      </v-col>
    </v-row>

  </v-container>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { formatDateDash } from "@/plugins/helpers";

const route = useRoute();
const router = useRouter();
const store = useStore();

const id = route.params.id || route.query.id;
const getSaleInvoiceDelivery = ref(null);
const pagePadding = ref(0);
const invoiceHeader = ref(true);

const getFileServerUrl = computed(() => store.getters.getFileServerUrl);

const todayDate = computed(() => {
  const today = new Date();
  return formatDateDash(today);
});

const getTotalQuantity = () => {
  if (!getSaleInvoiceDelivery.value?.invoice_delivery_details) return 0;
  return getSaleInvoiceDelivery.value.invoice_delivery_details.reduce(
    (acc, item) => acc + Number(item.qty || 0),
    0
  );
};


const print = (isPad) => {
  if (isPad === 1) {
    invoiceHeader.value = true;
    pagePadding.value = 0;
  } else if (isPad === 0) {
    invoiceHeader.value = false;
    pagePadding.value = 100;
  }

  setTimeout(() => {
    const printContent = document.getElementById("printable-area").innerHTML;
    const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Challan Copy</title>
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          @page {
            size: A4;
            margin: ${pagePadding.value}px 0 0 0;
          }

          html, body {
            margin: 0;
            padding: 0;
            width: 100%;
            height: auto;
          }

          body {
            font-family: sans-serif;
            background: #fff;
            color: #000;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
            margin: 0;
            padding: 0;
          }

          .watermark {
            position: fixed;
            transform: translate(105%, 103%);
            z-index: 0;
          }

          .invoice-footer {
            margin-top: auto;
            position: fixed;
            left; 0;
            bottom: 15px;
            width: 100%;    
          }

          .report-paper {
            width: 100%;
            padding: 0 !important;
            background: #fff;
            margin: 0;
          }

          table {
            width: 100%;
            margin: 0;
            padding: 0;
            border-collapse: collapse;
          }

          .page-header {
            display: table;
            width: 100%;
            margin: 0;
            padding: 0;
          }

          .company-name {
            font-size: 16px;
            font-weight: bold;
            text-transform: uppercase;
            margin: 0 0 4px 0;
          }

          .company-text {
            font-size: 16px;
            margin: 2px 0;
          }

          .logo-container img {
            max-height: 70px;
            max-width: 150px;
          }

          .info-row {
            
          }

          .details-table {
            width: 100%;
            border-collapse: collapse;
            font-size: 16px;
          }

          .dep-table th,
          .dep-table td {
            border: 1px solid #000;
            padding: 1px;
          }

          thead {
            display: table-header-group;
            //page-break-inside: avoid;
          }

          tfoot {
            display: table-footer-group;
            //page-break-inside: avoid;
          }

          tbody {
            display: table-row-group;
          }

          tr {
            //page-break-inside: avoid;
          }

          @media print {
            body {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
              background: white !important;
              margin: 0;
              padding: 0;
            }

            .page-header {
              display: table;
              width: 100%;
              page-break-after: avoid;
            }

            table {
              //page-break-inside: avoid;
            }
          }
        </style>
      </head>
      <body>
        ${printContent}
      </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
    }, 500);
    invoiceHeader.value = true;
    pagePadding.value = 0;
  }, 500);
};

onMounted(async () => {
  try {
    const res = await store.dispatch("getInvSalesInvoiceDeliveryById", id);
    getSaleInvoiceDelivery.value = res;
    console.log("Sales Invoice Delivery Data:", getSaleInvoiceDelivery.value);
  } catch (error) {
    console.error("Error fetching sales invoice delivery:", error);
  }
});
</script>

<style scoped>
.watermark {
  position: absolute;
  size: 50px;
  transform: translate(138%, 50%);
  z-index: 0; 
}
</style>
